import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {ContainerHandlingMode} from './container-handling/container-handling-rotterdam.component';

@Component({
  selector: 'app-berth-visit-container-rotterdam',
  templateUrl: './berth-visit-container-rotterdam.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BerthVisitContainerRotterdamComponent {
  protected readonly ContainerHandlingMode = ContainerHandlingMode;

  readonly berthVisitNumber = input.required<number>();
  readonly showLoading = input.required<boolean>();
  readonly showDischarge = input.required<boolean>();
  readonly showValidationErrors = input<boolean>(false);
}
